<div class="submit-container">
  <div>
    <template [ngTemplateOutlet]="template"></template>
  </div>
</div>